import moment from 'moment';
import _ from 'lodash';

export const filterTimeRangeResult = (response, timeRange) => {
  const begin = moment.utc(timeRange.begin, 'YYYY-MM-DD HH');
  const end = moment.utc(timeRange.end, 'YYYY-MM-DD HH');
  const stats = {};
  let startTime = moment.min(begin, end);
  const endTime = moment.max(begin, end);
  let emptyData;

  if (!_.isArray(response.stats)) {
    response.stats = [response.stats];
  }
  // 遍历出返回数据待取
  const dataByTime = {};
  _.forEach(response.stats, dataByDay => {
    _.forEach(dataByDay, (dataByHour, key) => {
      if (!emptyData) {
        // 用于补全时间, 需要获知数据类型
        if (_.isPlainObject(dataByHour)) {
          emptyData = {};
        }
        if (_.isArray(dataByHour)) {
          emptyData = [];
        }
      }
      dataByTime[key] = dataByHour;
    });
  });

  do {
    const key = startTime.format('YYYYMMDDHH');
    if (dataByTime[key]) {
      stats[key] = dataByTime[key];
    } else {
      stats[key] = _.clone(emptyData);
    }
    startTime = startTime.add(1, 'h');
  } while ((startTime.unix() || 0) < (endTime.unix() + 1 || 0));

  response.stats = stats;
  return response;
};

export const formatTimeRange = local_time_range => {
  const begin = moment.utc(local_time_range.begin).format('YYYY-MM-DD HH');
  const end = moment.utc(local_time_range.end).format('YYYY-MM-DD HH');
  return { begin, end };
};

const r_time_key = /\d{4}\d{2}\d{2}\d{2}/;

export const loopDataByHour = (data, payload) => {
  _.forEach(data, (dataByTimeKey, timeKey) => {
    if (r_time_key.test(timeKey)) {
      payload(dataByTimeKey, timeKey);
    }
  });
};

export const loopData = (data, payload) => {
  return loopDataByHour(data, payload);
};

export const loopDataByDay = (data, reduceHourFunc, reduceDayFunc) => {
  const zoneOffset = moment().utcOffset();
  const dayCount = {};
  loopDataByHour(data, (dataByTimeKey, timeKey) => {
    // 按本地时间天分组
    const dateTime = moment.utc(timeKey, 'YYYYMMDDHH').utcOffset(zoneOffset);
    const dateStr = dateTime.format('YYYY-MM-DD');

    if (!dayCount[dateStr]) {
      dayCount[dateStr] = {};
    }
    dayCount[dateStr][timeKey] = dataByTimeKey;
  });

  _.forEach(dayCount, dayData => {
    // 按天遍历
    const currentDay = [];
    loopData(dayData, (dataByTimeKey, timeKey) => {
      // 按本地天遍历每小时数据,使用按log累计到小时方法
      const hourData = reduceHourFunc(dataByTimeKey, timeKey);
      currentDay.push(hourData);
    });

    // 用每小时计算后的数据继续累计天数据, 使用按小时累计到天方法
    reduceDayFunc(currentDay);
  });
};

export const combineTimeData = (data, nextData, combineKey) => {
  let queryTimes = new Set([...data, ...nextData].map(x => x[combineKey]));
  queryTimes = [...queryTimes].sort((a, b) => a - b);
  const queryResult = [];
  queryTimes.forEach(s => {
    const convStart = data?.find(x => x[combineKey] === s) ?? {};
    const visitStart = nextData?.find(x => x[combineKey] === s) ?? {};
    delete convStart[combineKey];
    delete visitStart[combineKey];
    queryResult.push({
      ...convStart,
      ...visitStart,
      [combineKey]: s
    });
  });
  return queryResult;
};
